// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__QHi77","active":"button_active__67WuJ"};